import { motion, useAnimation } from 'framer-motion';
import SVGJSContainer, { textVariants } from '../../../utils/SVGJSContainer';
import NumberAnimate from "../../NumberAnimate";

function Immeubles4() {
  const controls = useAnimation();
  return (
    <SVGJSContainer controls={ controls }	>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="729"
        height="729"
        viewBox="0 0 729 729"
      >
        <defs>
          <linearGradient
            id="linear-gradientImmeubles4"
            x1="0.5"
            x2="0.5"
            y1="0.833"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#82a568"></stop>
            <stop offset="1" stopColor="#dcd747"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradientImmeubles4-2"
            x1="0.5"
            x2="0.5"
            y1="0.859"
            y2="0"
            xlinkHref="#linear-gradientImmeubles4"
          ></linearGradient>
          <linearGradient
            id="linear-gradientImmeubles4-3"
            x1="0.5"
            x2="0.5"
            y1="0.847"
            y2="0"
            xlinkHref="#linear-gradientImmeubles4"
          ></linearGradient>
          <linearGradient
            id="linear-gradientImmeubles4-4"
            x1="0.5"
            x2="0.5"
            y1="0.713"
            y2="0"
            xlinkHref="#linear-gradientImmeubles4"
          ></linearGradient>
          <linearGradient
            id="linear-gradientImmeubles4-5"
            x1="0.5"
            x2="0.5"
            y1="0.828"
            y2="0"
            xlinkHref="#linear-gradientImmeubles4"
          ></linearGradient>
        </defs>
        <g data-name="Groupe 2563" transform="translate(-1033 -2299.847)">
          <path
            fill="#e1ea65"
            d="M0 0H729V729H0z"
            data-name="Rectangle 2246"
            transform="translate(1033 2299.847)"
          ></path>
          <motion.text
            data-name="Par type"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="55"
            fontWeight="700"
            transform="translate(1492 2381)"
            variants={ textVariants }
            initial="hidden"
            animate={ controls }
          >
            <tspan x="0" y="0">
              Par type
            </tspan>
          </motion.text>
          <motion.text
            data-name="5,96 %"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="38"
            fontWeight="700"
            transform="translate(1391 2872)"
          >
            <tspan x="0" y="0">
              <NumberAnimate  tspan nb={7} suffix=" %" duration={2.5} delay={1} />
            </tspan>
          </motion.text>
          <text
            data-name="Essential coats what"
            fontFamily="AcuminPro, Acumin Pro"
            fontSize="25"
            letterSpacing="-.01em"
            transform="translate(1164 2836)"
          >
            <tspan x="-50" y="29">
              5 pièces et +
            </tspan>
          </text>
          <path
            fill="#82a568"
            d="M69 0a34.61 34.61 0 01-34.508 34.508A34.614 34.614 0 010 1.045"
            data-name="Tracé 30455"
            transform="rotate(-90 2135.028 836.972)"
          ></path>
          <path
            fill="url(#linear-gradientImmeubles4)"
            d="M0 0v276.056a34.61 34.61 0 0034.508 34.508 34.609 34.609 0 0034.507-34.508V0z"
            data-name="Tracé 30458"
            transform="rotate(-90 1933.519 637.519)"
          ></path>
          <path
            fill="url(#linear-gradientImmeubles4-2)"
            d="M0 0v256.25c0 17.617 15.529 32.032 34.508 32.032 18.979 0 34.507-14.415 34.507-32.032V0z"
            data-name="Tracé 30459"
            transform="rotate(-90 2014.356 716.926)"

          ></path>
          <path
            fill="url(#linear-gradientImmeubles4-3)"
            d="M0 0v227.805c0 15.662 15.529 28.477 34.508 28.477 18.979 0 34.507-12.815 34.507-28.477V0z"
            data-name="Tracé 30460"
            transform="rotate(-90 2054.478 757.048)"
          ></path>
          <path
            fill="url(#linear-gradientImmeubles4-4)"
            d="M69.015 0v44.068a34.61 34.61 0 01-34.508 34.508A34.609 34.609 0 010 44.068V0"
            data-name="Tracé 30461"
            transform="rotate(-90 2094.386 797.385)"
          ></path>
          <path
            fill="url(#linear-gradientImmeubles4-5)"
            d="M0 0v276.056a34.61 34.61 0 0034.508 34.508 34.609 34.609 0 0034.507-34.508V0z"
            data-name="Tracé 30462"
            transform="rotate(-90 1973.519 677.519)"
          ></path>
          <path
            fill="none"
            stroke="#000"
            strokeWidth="2"
            d="M0 0L0 531"
            data-name="Ligne 686"
            transform="translate(1281.5 2465.5)"
          ></path>
					<motion.text
            data-name="5,96 %"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="30"
            fontWeight="700"
            transform="translate(1381 2870)"
          >
            <tspan x="-30" y="80">
              <NumberAnimate  tspan nb={1} suffix=" %" duration={.5} delay={1} />
            </tspan>
          </motion.text>
          <text
            data-name="Essential coats what"
            fontFamily="AcuminPro, Acumin Pro"
            fontSize="25"
            letterSpacing="-.01em"
            transform="translate(1154 2919)"
          >
            <tspan x="-90" y="29">
              Chambres isolées
            </tspan>
          </text>
					<motion.text
            data-name="5,96 %"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="42"
            fontWeight="700"
            transform="translate(1391 2872)"
          >
            <tspan x="180" y="-80">
              <NumberAnimate  tspan nb={14} suffix=" %" duration={1} delay={2} />
            </tspan>
          </motion.text>
          <text
            data-name="Essential coats what"
            fontFamily="AcuminPro, Acumin Pro"
            fontSize="25"

            letterSpacing="-.01em"
            transform="translate(1170 2756)"
          >
            <tspan x="-50" y="29">
              Studios et T1
            </tspan>
          </text>
					<motion.text
            data-name="5,96 %"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="50"
            fontWeight="700"
            transform="translate(1391 2876)"
          >
            <tspan x="226" y="-240">
              <NumberAnimate  tspan nb={28} suffix=" %" duration={2.5} delay={1} />
            </tspan>
          </motion.text>
          <text
            data-name="Essential coats what"
            fontFamily="AcuminPro, Acumin Pro"
            fontSize="25"
            letterSpacing="-.01em"
            transform="translate(1184 2593)"
          >
            <tspan x="-15" y="29">
              3 pièces
            </tspan>
          </text>
					<motion.text
            data-name="5,96 %"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="45"
            fontWeight="700"
            transform="translate(1391 2872)"
          >
            <tspan x="210" y="-160">
              <NumberAnimate  tspan nb={20} suffix=" %" duration={1.5} delay={1.5} />
            </tspan>
          </motion.text>
          <text
            data-name="Essential coats what"
            fontFamily="AcuminPro, Acumin Pro"
            fontSize="25"
            letterSpacing="-.01em"
            transform="translate(1180 2673)"
          >
            <tspan x="-15" y="29">
              4 pièces
            </tspan>
          </text>
					<motion.text
            data-name="5,96 %"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="50"
            fontWeight="700"
            transform="translate(1391 2872)"
          >
            <tspan x="230" y="-323">
              <NumberAnimate  tspan nb={30} suffix=" %" duration={2} delay={1.2} />
            </tspan>
          </motion.text>
          <text
            data-name="Essential coats what"
            fontFamily="AcuminPro, Acumin Pro"
            fontSize="25"
            letterSpacing="-.01em"
            transform="translate(1184 2513)"
          >
            <tspan x="-15" y="29">
              2 pièces
            </tspan>
          </text>
        </g>
      </svg>
    </SVGJSContainer>
  );
}

export default Immeubles4;
